var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{class:{active: _vm.selected},style:({minWidth: _vm.minWidth + 'px'}),attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }